module.exports = __webpack_public_path__ + "static/img/logo11.e97d29a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/logo11.png
// module id = 2wVE
// module chunks = 1